<template>
  <div>
      <pbc-posts id="chromebugworkaround"
                  :class="pbcPostsClass"
                  :posts='posts'
                  :type='type'
                  :ignore-global-pause='ignoreGlobalPause'
                  @reply='reply'
                  @load-more='onLoadMore'
                  @view-post='onViewPost'
                  >

        <template #default='{}'>
          <div v-if='!disableCta' class="w-full">

            <slot name="before-posts" />

            <pbcCta class="scroll-snap-to"/>


            <!--
            <p class='text-white'>HI {{highestIndexVisible}}</p>
            <p class='text-white'>FROMS {{fromHot}} / {{fromNew}} / {{from}}</p>
            -->

            <div id="type-box" class="scroll-snap-to-start">
              <div id="what-viewing-box" class="text-lg text-gray-600 text-center w-full">
                You are viewing
                <router-link v-if='!disableTypeSelection' :to="isHot ? {name:'new'} : {name:'hot'}" class="mr-2 w-12 py-2 mx-0">
                  <new-or-hot :value='isHot' size='large' class="mt-4" />
                </router-link>

              </div>

            </div>

            <div v-if='authError' class="md:max-w-md mt-12 border-blue-800 border rounded w-full p-4">
              <h1 class="text-white font-bold text-2xl">You have been logged out.</h1>
            </div>

            <div v-else-if='error && posts.length === 0' class="md:max-w-md mt-12 border-blue-800 border rounded w-full p-4">
              <h1 class="text-white font-bold text-2xl">Something went wrong while loading posts... please try again.</h1>
            </div>

            <pbc-error v-if='error' @retry='onRetry' :error='(loadMoreError||error).toString()' :retry='true' message='Could not get posts.' />
            <pbc-error v-else-if='loadMoreError' :error='(loadMoreError).toString()' :retry='false' message='Could not get more posts.' @close='onRetry' />
          </div>
        </template>

        <template #before-post='{i}'>
          <inline-app-install-dialog class="scroll-snap-to-end pb-12"
                                     v-if='canInstallApp && shouldShowInlineAppInstallPrompt(i)' />
        </template>

        <template #after='{}'>
          <div v-if='!disableLoadMore && !reachedEnd && parent === "" && !isLoading' class="mx-auto p-4 text-lg text-white mt-4 mb-8">
            <router-link :to="loadMoreLink" class="outline-button underline text-lg p-2">Load More</router-link>
          </div>
        </template>
     </pbc-posts>
      <posts-loading v-if='!loadMoreError && isLoading' />
  </div>

</template>
<script>
const isServer = !process.browser;

import NewOrHot from '@ui/atoms/NewOrHot.vue';
import PostsLoading from '@ui/molecules/PostsLoading.vue';
import InlineAppInstallDialog from '@/ui/molecules/InlineAppInstallDialog.vue';
import UAParser from 'ua-parser-js';
import pbcCta from '@ui/atoms/PbcCta.vue'

import { postAddedSubscription } from '@/gql/Queries.js';
import { debounce, uniqBy } from 'lodash';
import { getPostsForQuery } from '@/gql/Queries.js';
import PbcPosts from './PbcPosts.vue';
import gql from 'graphql-tag'
import { mapState } from 'vuex';
export default {
  props: {
    parent: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'hot'
    },
    disableTypeSelection: {
      type: Boolean,
      default: false
    },
    feedType:{
      type: String,
      default: ""
    },
    disableCta:{
      type:Boolean,
      default:false
    },
    pbcPostsClass:{
      type:String,
      default:'pbc-posts-hor'
    },
    ignoreGlobalPause:{
      type:Boolean,
      default:false
    },
    staticType:{
      type:Boolean,
      default:false
    },
    disableLoadMore:{
      type:Boolean,
      default:false
    }
  },
  apollo:{
    getPostsFor:{
      query:getPostsForQuery,
      fetchPolicy:isServer ? 'network-only' : 'cache-and-network',
      variables() {
        if (this.isServer) {
          const {parent, size, type, nextToken} = this;
          return {
            parent,
            size,
            type,
            nextToken
          }
        } else {
          const {parent, size, type, nextToken} = this;
          return {
            parent,
            size,
            type,
            nextToken
          }
        }
      },
      result(data) {
        this.onLoadedPosts(data);
      },
      error(err) {
        this.onLoadError(err);
        // this is so the server always shows the newest posts
        if (this.isServer || this.fromToken === '') {
          //this.posts = [];
        }
      },
      /*
      subscribeToMore:{
        document:a,
        updateQuery: (previousResult, a) => {
        }
      }
      */
    }
  },
  components: {
    PbcPosts,
    InlineAppInstallDialog,
    pbcCta,
    PostsLoading,
    NewOrHot
  },
  created() {
    console.log('create the component', this.isServer);
    if (this.$route.query.fromToken) {
      this.fromToken = this.$route.query.fromToken;
      console.log('have fromToken fromToken query', this.fromToken);
    } else if (this.isServer) {
      console.log('is server, set fromToken to 0');

      this.fromToken = '';
    }
  },
  async mounted() {
    console.log('mount it', this.isServer);
    this.$eventbus.on('inlineAppInstall', this.onInlineAppInstallPrompt);

    if (this.$route.query.posted) {
      // what a hack
      //this.posts = [];

      this.fromToken = '';

      await this.$apollo.queries.getPostsFor.refetch();

      this.$router.replace({
        query:{
          posted:undefined
        }
      });
    }
  },
  beforeDestroy() {
    this.$eventbus.off('inlineAppInstall', this.onInlineAppInstallPrompt);
  },
  data() {

    const loadMorePosts = this._loadMorePosts;
    const uaparser = new UAParser();
    const nextToken = this.$route.query.fromToken || '';
    //const loadMorePosts = this._loadMorePosts;

    return {
      loadMorePosts,
      highestIndexVisible:-1,
      reachedEnd: false,
      size: 10, // NOTE: NB: do NOT change this without changing in CreatePost as well - apollo needs to know the arguments to update the cache.
      //size: 5, // NOTE: NB: do NOT change this without changing in CreatePost as well - apollo needs to know the arguments to update the cache.
      getPostsForQuery,
      postAddedSubscription,
      loadingPartial: false,
      //lePosts:[],
      getPostsFor:{
        items:[]
      },
      authError:false,
      //enableChromeBugWorkaround:process.browser ? uaparser.getBrowser().name.toLowerCase().includes('chrome') : false,
      enableChromeBugWorkaround: false,
      lastType:this.type,
      showInlineAppInstallPrompt:false,
      loadError:false,
      loadMoreError:null,
      error:undefined,
      postsLoaded:[],
      nextToken,
      fromToken:''

    }
  },
  methods: {
    async onRetry() {
      if (this.authError) {
        this.$router.push({
          name:'login'
        });
        return;
      }
      this.loadMoreError = null;
      this.error = undefined;
      this.authError = undefined;
      this.nextToken = '';
      await this.$apollo.queries.getPostsFor.refetch();
    },
    onLoadError(err) {
      if (((err||{}).networkError||{}).statusCode === 401) {
        console.error('catch error', JSON.stringify(err));
        this.authError = true;
        this.error = err;
      }
      this.error = err;
    },
    onViewPost({post,i}) {
      this.$store.commit('setViewingPostId', {
        type:this.type,
        id:post.id
      });
      this.highestIndexVisible = i;
      this.$router.replace({
        name:this.feed,
        hash:'p'+post.id
      });
    },
    shouldShowInlineAppInstallPrompt(i) {
      return i > 1 && ((i - 1) % 5 === 0);
    },
    onInlineAppInstallPrompt() {
      //this.showInlineAppInstallPrompt = this.highestIndexVisible + 1;
      this.showInlineAppInstallPrompt = true;
    },
    onLoadedPosts({data,loading,stale}) {
      console.log('loaded posts', data, loading, stale);
      this.waiting = false;

      if (stale || loading || !data) {
        return;
      }
      this.postsLoaded = uniqBy(this.postsLoaded.concat([...data.getPostsFor.items]), ({id}) => {
        return id;
      });;

      if (!this.isServer && !data.loading) {
        if (this.posts.length) {
          this.$nextTick( () => {
            this.$eventbus.emit('postsLoaded');
          });
        }
      }

    },
    getNextPage() {
      const lengthBefore = this.posts.length;
      const size = this.size;
      const numToLoad = this.size;
      const loadUpUntil = numToLoad + this.highestIndexVisible;
      //const shouldLoad = Math.max(0, loadUpUntil - lengthBefore) > 2;
      const shouldLoad = true;
      return {
        size,
        shouldLoad
      }
    },
    async _loadMorePosts() {
      try {
        console.log('will load your posts');

        const {size,shouldLoad} = this.getNextPage();
        console.log('111size,fromToken',size,shouldLoad);
        if (!shouldLoad) {
          this.waiting = false
          return;
        }

        this.$store.commit('loadPosts', {
          type:this.type,
          from:this.nextToken
        });

        console.log('next', this.getPostsFor.nextToken);
        await this.fetchMore(this.getPostsFor.nextToken);

        this.waiting = false
        /*
        this.size = size;
        console.log('size,from',size,from);
        await this.$apollo.queries.getPostsFor.refetch();
        this.waiting = false
        this.loadingPartial = false;
        */
      } catch (e) {
        this.waiting = false;
      }
    },
    async onLoadMore(highestIndexVisible) {
      if (this.enableChromeBugWorkaround) {
        this.chromeScrollWorkaround = document.querySelector("#chromebugworkaround").scrollTop;
        this.oldHighestIndexVisible = highestIndexVisible;
      }
      if (this.waiting) {
        console.log('already loading');
        return;
      }

      if (highestIndexVisible > this.highestIndexVisible) {
        console.log('in the loopie loop');
        this.highestIndexVisible = highestIndexVisible;

        this.waiting = true;
        await this.loadMorePosts();

        if (this.enableChromeBugWorkaround) {
          window.requestAnimationFrame( () => {
            const currentScrollTop = document.querySelector("#chromebugworkaround").scrollTop;
            if (currentScrollTop < this.chromeScrollWorkaround - window.innerHeight / 3) {
              //document.querySelector("#chromebugworkaround").scrollTop = this.chromeScrollWorkaround;

              const lolpost = this.posts[this.oldHighestIndexVisible];
              document.querySelector("#p" + lolpost.id).scrollIntoView();
            }
          });
        }
      } else {
        console.log('are you at the end or whats going on?');
      }
    },
    subscribeUpdateQuery(previousResult, { subscriptionData }) {
      const items = [subscriptionData.data.addedPost, ...previousResult.getPostsFor.items ]
      const total = items.length;
      return {
        getPostsFor: {
          __typename: previousResult.getPostsFor.__typename,
          items,
          total
        }
      }
    },

    async getGameData(id) {
      const data = await this.$apollo.query({
        query:gql(`
        query getGame($id: String!) {
          getGame(id: $id)
        }
        `),
        variables: {
          id
        }
      });
      const d = JSON.parse(data.data.getGame);
      d.id = id;
      return d;
    },
    async fetchMore(from) {
      this.loadingPartial = true;
      this.nextToken = from;
    },
    reply(post) {
      this.$router.push({
        name:'start',
        params:{
          parentId:post.id
        }
      })
    },
  },
  computed: {
    isServer() {
      return !process.browser;
    },
    posts() {
      return this.postsLoaded;
      return this.getPostsFor.items;
    },
    /*
    posts: {
      set(nv) {
        this.lePosts = nv;
      },
      get() {
        return this.lePosts;
      }
    },
    */
    isLoading() {
      return this.$apollo.loading && !this.loadingPartial;
    },
    loadMoreLink() {
      const {nextToken} = this.getPostsFor;
      //const nextToken = '';
      return {
        query:{
          fromToken:nextToken,
        },
      }
    },
    isHot: {
      get() {
        const anyRouteIsHot = this.$route.matched.filter( ({name}) => {
          return name === 'hot';
        }).length > 0;
        const anyRouteIsNew = this.$route.matched.filter( ({name}) => {
          return name === 'new';
        }).length > 0;
        return anyRouteIsHot && !anyRouteIsNew;
      }
    },
    isNew: {
      get() {
        const anyRouteIsNew = this.$route.matched.filter( ({name}) => {
          return name === 'new';
        }).length > 0;
        return anyRouteIsNew;
      }
    },

    ...mapState(['canInstallApp', 'viewPosts', 'viewingPostId', 'postsNew', 'postsHot', 'fromNew', 'fromHot', 'justPosted']),
  },
  watch:{
    '$route.query.from'(nv) {
      console.log('CHANGE IN THE QUERRASDASDASDASD', nv);
      if (this.isServer) {
        this.fromToken = nv;
      } else {
        this.fetchMore(nv);
      }
    },
    type(nv, ov) {
      this.highestIndexVisible = -1;
      this.postsLoaded = [];
      this.nextToken = '';
    },
    /*
    justPosted:{
      immediate:true,
      handler(nv) {
        this.from = 0;
        this.$apollo.queries.getPostsFor.refetch();
        this.$store.commit('bla');
      }
    }
    */
  }
}
</script>
<style>
.cta-background {
  background-color: #191F2B
}
</style>
